// React
import { useCallback } from 'react';
import { CardFooter, Col } from 'reactstrap';
import DataTable from 'react-data-table-component';

// Containers Injections
import { notifyError } from '../../../../containers/componentsInjection';

// Utils
import { APIClient } from '../../../../../../helpers/api_helper';
import { openPdfWithBase64 } from '../../../../../../utils/openPdfWithBase64';
import { payrollDeductionColumns } from '../../common/payrollDeductionColumns';

const PayrollDeduction = ({ validation, payrollData }) => {
  let dataTest = [];

  const api = new APIClient();

  const handleSubmit = () => {
    let organizationsArray = validation.values.organizationInput.map((item) => {
      return item.value;
    });

    const selectedIds = dataTest.selectedRows.map((row) => Number(row.id));

    const data = {
      starts: validation.values.periodStarts || null,
      ends: validation.values.periodEnds || null,
      organization_id: organizationsArray || null,
      proposal_status_id:
        validation.values.proposalSituationInput.value || null,
      status: validation.values.statusType || null,
      instructions: validation.values.instructions || null,
      selectedRows: selectedIds,
    };

    api
      .create('/reports/financial/payroll-discount', data)
      .then((response) => {
        openPdfWithBase64(response.data, 'Desconto em Folha');
      })
      .catch((error) => {
        notifyError(error.response.data.messages.error);
      });
  };

  const handleChange = useCallback(
    (item) => {
      dataTest = item;
    },
    [dataTest]
  );

  const rowSelectCritera = () => true;

  return (
    <div className="mb-4">
      {payrollData.length > 0 && (
        <>
          <DataTable
            data={payrollData || []}
            columns={payrollDeductionColumns}
            selectableRows
            selectableRowSelected={rowSelectCritera}
            onSelectedRowsChange={handleChange}
          />
          <CardFooter>
            <Col md={12}>
              <div className="text-end d-flex justify-content-end">
                <button
                  type="submit"
                  onClick={() => handleSubmit()}
                  className="btn btn-primary "
                >
                  Gerar Relatório
                </button>
              </div>
            </Col>
          </CardFooter>
        </>
      )}
    </div>
  );
};

export default PayrollDeduction;
